// export function showFrame() {
//     parent.EngageBay_Livechat.ref.visibleFrame();
//     this.resizeFrame((this.isOpened || this.showWelcomePrompt) ? 'WINDOW_OPENED' : 'WINDOW_CLOSED');
// }555
import { ChatSessionConnectedWithEnum, MessageByTypeEnum, } from "./Models";
import Browser from "browser-detect";
import EMOJILIST from "./emoji-list";
import { DEFAULT_BOT_ICON, FORM_DATA, PARENT_WINDOW_LIVECHAT_REF, } from "./globals";
import { getLocalStoragePrefs } from "./Storage";
var EMOJI = require("emojis-list");
// export function resizeFrame(type: string) {
//     parent.EngageBay_Livechat.ref.UI().resize(type);
// },
// export const showFrame = (isOpened: any, showWelcomePrompt: any) => {
//     parent.EngageBay_Livechat.ref.visibleFrame();
//     resizeFrame((isOpened || showWelcomePrompt) ? 'WINDOW_OPENED' : 'WINDOW_CLOSED');
// };
// export const resizeFrame = (type: any) => {
//     parent.EngageBay_Livechat.ref.UI().resize(type);
// };
export var getOperator = function (id, agents) {
    return agents === null || agents === void 0 ? void 0 : agents.find(function (agent) {
        return agent.id == id;
    });
};
export var resizeFrame = function (type) {
    try {
        window.parent.EngageBay_Livechat.ref.UI().resize(type);
    }
    catch (error) { }
};
export var loadBgAssetImage = function (url) {
    return ("background-image: url(" +
        (url.indexOf("../") > -1 ? require(url) : url) +
        ")");
};
export var getFormData = function () {
    var formData = getLocalStoragePrefs(FORM_DATA);
    var dataJSON = {};
    if (formData)
        dataJSON = JSON.parse(formData);
    try {
        var email = window.parent.EhAccount.getEmail();
        var name_1 = window.parent.EhAccount.getName();
        if (email)
            dataJSON.email = email;
        if (name_1)
            dataJSON.name = name_1;
    }
    catch (error) {
        // console.log("error", error);
    }
    return JSON.stringify(dataJSON);
};
export var getFormMetaData = function () {
    // Browser
    var browser = getBrowserInfo();
    var meta = {};
    meta.browser_info = browser;
    // Form data if any
    var formData = getFormData();
    if (formData) {
        // Reset first message
        formData = JSON.parse(formData);
        meta.user_info = formData;
    }
    return meta;
};
export var getOperatorImage = function (id, agents, chatPrefs) {
    //const agent = getOperator(id, agents);
    // return agent?.profile_img_url || chatPrefs.widget.default_profile_image || "boticon";
    return DEFAULT_BOT_ICON;
};
export var getOperatorName = function (id, agents) {
    var agent = getOperator(id, agents);
    return (agent === null || agent === void 0 ? void 0 : agent.name) || "You";
};
export var promptImg = function (user_id, agents, chatPrefs) {
    var agent = agents === null || agents === void 0 ? void 0 : agents.find(function (agent) {
        return agent.id === user_id;
    });
    return agent && agent.profile_img_url
        ? agent.profile_img_url
        : chatPrefs === null || chatPrefs === void 0 ? void 0 : chatPrefs.widget.default_profile_image;
};
export var pushMessage = function (message, session) {
    if (!session) {
        // console.log("Session not found");
        // if (activeSessionDetails.session_type == SessionStateEnum.NEW_SESSION) {
        //   activeSessionDetails.session?.message_list.push(message);
        //   setActiveSessionDetails(activeSessionDetails);
        // }
        return;
    }
    // console.log("pushing new messge to", message.session_id);
    // Get session from session id
    // let session = getSessionById(message.session_id);
    // console.log("having session", session);
    if (!session)
        return;
    // Update time of the session
    session.updated_time = parseInt((new Date().getTime() / 1000).toString());
    // Set unread count
    // if (!activeSessionDetails?.session_id || !activeSessionDetails?.session || activeSessionDetails.session.id != session.id) {
    //   console.log("updating unread");
    //   session.unRead = session.unRead ? session.unRead + 1 : 1;
    // }
    session.unRead = session.unRead ? session.unRead + 1 : 1;
    // Push message
    var matchFound = false;
    session.message_list.forEach(function (eachMessage, index) {
        if (eachMessage.id == message.id && session) {
            matchFound = true;
            session.message_list[index] = message;
        }
    });
    if (!matchFound)
        session.message_list.push(message);
    if (message.from == "Agent")
        session.connected_with = ChatSessionConnectedWithEnum.AGENT;
    if (message.from != "Visitor") {
        // Play sound
        playSound();
        // Update document title for
        blinkTitle(message.message);
    }
    if (message.from === "Agent") {
        // Close typing
        session.typing = false;
    }
};
export var playSound = function () {
    try {
        window.parent.EngageBay_Livechat.ref.playSound("https://d2p078bqz5urf7.cloudfront.net/cloud/assets/sounds/track3.mp3");
    }
    catch (error) {
        // console.error("Error playing notification sound:", error);
    }
};
export var blinkTitle = function (message) {
    try {
        window.parent.EngageBay_Livechat.ref.blinkTitle(message);
    }
    catch (error) {
        // console.error("Error blinking title:", error);
    }
};
export var getOperatorFromSession = function (session, agents) {
    var _a;
    var userId = undefined;
    try {
        if (session === null || session === void 0 ? void 0 : session.message_list) {
            for (var i = 0; i < ((_a = session === null || session === void 0 ? void 0 : session.message_list) === null || _a === void 0 ? void 0 : _a.length); i++) {
                if (session.message_list[i].from == MessageByTypeEnum.Agent &&
                    session.message_list[i].user_id)
                    userId = session.message_list[i].user_id;
            }
        }
    }
    catch (e) { }
    if (!userId)
        userId =
            session && session.first_answered_by_user_id
                ? session.first_answered_by_user_id
                : 0;
    return userId ? getOperator(userId, agents) : undefined;
};
export function isValidTicketField(field) {
    if (field.required && (!field.value || field.value.length === 0)) {
        field.is_valid = false;
        field.error = "This field is required";
        return field;
    }
    if (!field.value) {
        field.is_valid = true;
        field.error = "";
        return field;
    }
    var isValid = true;
    var error = "";
    switch (field.type) {
        case "text":
            break;
        case "list":
            break;
        case "email":
            var match = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(field.value.toString());
            if (!match) {
                isValid = false;
                error = "Invalid field";
            }
            break;
    }
    field.is_valid = isValid;
    if (!isValid)
        field.error = error;
    else
        field.error = "";
    return field;
}
export function isValidField(field) {
    if (field.required && (!field.value || field.value.length === 0)) {
        field.is_valid = false;
        field.error = "This field is required";
        return field;
    }
    if (!field.value) {
        field.is_valid = true;
        field.error = "";
        return field;
    }
    try {
        if (field.value instanceof String)
            field.value = field.value.trim();
    }
    catch (error) { }
    if (field.pattern) {
        var pattern = new RegExp(field.pattern);
        if (pattern && field.value && !pattern.test(field.value + "")) {
            field.is_valid = false;
            field.error = "Invalid field";
            return field;
        }
    }
    var isValid = true;
    var error = "";
    switch (field.type) {
        case "text":
            break;
        case "list":
            break;
        case "email":
            var match = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(field.value.toString());
            if (!match) {
                isValid = false;
                error = "Invalid field";
            }
            break;
        case "checkbox":
            break;
        case "multicheckbox":
            break;
        case "date":
            break;
        case "file":
            break;
        case "url":
            var pattern = new RegExp("^(https?:\\/\\/)?" + // protocol
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
                "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
                "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
                "(\\#[-a-z\\d_]*)?$", "i"); // fragment locator
            if (!pattern.test(field.value + ""))
                isValid = false;
            break;
        case "textarea":
            break;
        default:
            break;
    }
    field.is_valid = isValid;
    if (!isValid)
        field.error = error;
    else
        field.error = "";
    return field;
}
export function getBrowserInfo() {
    var json = {
        OS: Browser().os,
        browser: Browser().name,
        version: Browser().version,
        mobile: Browser().mobile,
    };
    return json;
}
export function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export function formatBytes(bytes, decimals) {
    if (bytes == 0)
        return "0 Bytes";
    var k = 1024, dm = decimals <= 0 ? 0 : decimals || 2, sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
// export function blinkTitle(message:any) {
//     var that = EngageBay_Livechat.ref, originalTitle = "";
//     var blink = function() {
//         document.title = document.title == message ? originalTitle
//                 : message;
//     }, /* function to BLINK browser tab */
//     clear = function() { /* function to set title back to original */
//         if (that.timeoutId)
//             clearInterval(that.timeoutId);
//         if (originalTitle)
//             document.title = originalTitle;
//         that.timeoutId = null;
//     };
//     clear();
//     originalTitle = document.title;
//     if (!that.timeoutId) {
//         that.timeoutId = setInterval(blink, 1000);
//     }
//     // Add focus event
//     window.onfocus = function() {
//         clear();
//     };
// }
export var getRealTime = function (timestamp) {
    var date = new Date(timestamp);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    var adjustedHours = hours % 12 || 12;
    var formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    return "".concat(adjustedHours, ":").concat(formattedMinutes, " ").concat(ampm);
};
export function convertEmojis(text) {
    try {
        var emoji_array = [], emoji_json = {}, b = /[[\]{}()*+?.\\|^$\-,&#\s]/gi;
        for (var i = 0; i < EMOJILIST.length; i++) {
            emoji_json[EMOJILIST[i].title] = EMOJILIST[i];
            emoji_array.push("(" + EMOJILIST[i].title.replace(b, "\\$&") + ")");
        }
        return text.replace(new RegExp(emoji_array.join("|"), "gi"), function (g) {
            g = g === undefined ? g : g.toUpperCase();
            var css = "border: 0px;vertical-align: middle;background-color: transparent;display: inline-block; height: 16px; width: 16px; background-position: " +
                emoji_json[g].position;
            return typeof emoji_json[g] != "undefined"
                ? '<span class="engagebay-emoji-picker-image" aria-label="' +
                    emoji_json[g].label +
                    '" style="' +
                    css +
                    '"></span>'
                : g;
        });
    }
    catch (error) { }
    return text;
}
/**
 * Convert links to anchor tags
 *
 * @param {Create} text
 */
export function createTextLinks_(text) {
    try {
        return (text || "").replace(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi, function (match, space, url) {
            var hyperlink = url;
            if (!hyperlink.match("^https?://")) {
                hyperlink = "http://" + hyperlink;
            }
            return (space + '<a target="_blank" href="' + hyperlink + '">' + url + "</a>");
        });
    }
    catch (e) { }
    return text;
}
export function isGPTEnabled() {
    var _a, _b;
    return PARENT_WINDOW_LIVECHAT_REF &&
        ((_b = (_a = PARENT_WINDOW_LIVECHAT_REF.ref.settings) === null || _a === void 0 ? void 0 : _a.botPrefs) === null || _b === void 0 ? void 0 : _b.length) > 0
        ? true
        : false;
}
export function fileName(message) {
    try {
        return JSON.parse(message.message).fileName;
    }
    catch (error) {
        return "";
    }
}
export function ifAnImage(message) {
    var imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".webp",
        ".svg",
        ".gif",
        ".jpe",
        ".ico",
        ".jfif",
        ".bmp",
    ];
    try {
        return imageExtensions.some(function (ext) {
            return JSON.parse(message.message).fileName.endsWith(ext);
        });
    }
    catch (error) {
        return false;
    }
}
export function fileUrl(message) {
    try {
        return JSON.parse(message.message).fileUrl;
    }
    catch (error) {
        return "";
    }
}
export function fileSize(message) {
    try {
        return formatBytes(JSON.parse(message.message).fileSize, 0);
    }
    catch (error) {
        return "";
    }
}
export function getSystemMessage(type) {
    var message = type;
    switch (type) {
        case "ASK_USER_DETAILS":
            message =
                PARENT_WINDOW_LIVECHAT_REF.ref.settings.systemMessage[type + "_TO_VISITOR"];
            break;
        case "CHAT_SESSION_CLOSED":
            message =
                PARENT_WINDOW_LIVECHAT_REF.ref.settings.systemMessage[type + "_TO_VISITOR"];
            break;
        default:
            break;
    }
    return message;
}
